import React from 'react';
import { FileCheck, UserCheck, ClipboardList, Calendar, CheckCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../Components/ui/card';
import { Badge } from '../Components/ui/badge';
import { Progress } from '../Components/ui/progress';

export default function EBoarding() {
  const onboardingSteps = [
    { id: 1, title: 'Document Verification', icon: FileCheck, status: 'Completed', progress: 100, color: 'green' },
    { id: 2, title: 'Background Check', icon: UserCheck, status: 'In Progress', progress: 60, color: 'blue' },
    { id: 3, title: 'Training Schedule', icon: ClipboardList, status: 'Pending', progress: 0, color: 'gray' },
    { id: 4, title: 'Orientation', icon: Calendar, status: 'Pending', progress: 0, color: 'gray' },
  ];

  const statusColors = {
    'Completed': 'bg-green-100 text-green-800 border-green-300',
    'In Progress': 'bg-blue-100 text-blue-800 border-blue-300',
    'Pending': 'bg-gray-100 text-gray-800 border-gray-300'
  };

  return (
    <div className="max-w-[1600px] mx-auto space-y-6">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div className="flex items-center space-x-3">
          <div className="bg-gradient-to-br from-indigo-500 to-indigo-600 p-3 rounded-lg">
            <CheckCircle className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">eBoarding</h1>
            <p className="text-sm text-gray-500">Employee onboarding management</p>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {onboardingSteps.map((step) => {
          const Icon = step.icon;
          return (
            <Card key={step.id} className="hover:shadow-lg transition-all duration-300 border border-gray-200">
              <CardHeader className="pb-3">
                <div className="flex items-start justify-between">
                  <div className="flex items-center space-x-3">
                    <div className={`p-3 rounded-lg ${
                      step.color === 'green' ? 'bg-green-100' :
                      step.color === 'blue' ? 'bg-blue-100' : 'bg-gray-100'
                    }`}>
                      <Icon className={`h-6 w-6 ${
                        step.color === 'green' ? 'text-green-600' :
                        step.color === 'blue' ? 'text-blue-600' : 'text-gray-600'
                      }`} />
                    </div>
                    <div>
                      <CardTitle className="text-lg">{step.title}</CardTitle>
                      <Badge className={`${statusColors[step.status]} border mt-1`}>
                        {step.status}
                      </Badge>
                    </div>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <div className="space-y-2">
                  <div className="flex items-center justify-between text-sm">
                    <span className="text-gray-600">Progress</span>
                    <span className="font-semibold">{step.progress}%</span>
                  </div>
                  <Progress value={step.progress} className="h-2" />
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      <Card className="shadow-sm">
        <CardHeader className="border-b bg-gray-50/50">
          <CardTitle className="text-lg">Onboarding Pipeline</CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="text-center text-gray-500 py-12">
            <CheckCircle className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">No active onboarding</h3>
            <p className="text-gray-500">New hires will appear here during onboarding</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}